const styles = {
  flexPaddingI: { padding: "0px", paddingTop: "0px", width:"100%" },
  flexPadding: { padding: "24px", paddingTop: "0px" },
  flex: { display: "flex" },
  flexB: { display: "flex", flexGrow: 2 },
  flexColumn: { display: "flex", flexDirection: "column" },
  flexRow: { display: "inline-flex", flexDirection: "row", flexWrap: "wrap", flexGrow: 1 },
  leftColB: { flex: 2, marginRight: "1em" },
  leftCol: { flex: 1, marginRight: "1em" },
  rightCol: { flex: 1, marginLeft: "1em" },
  singleCol: { marginTop: "2em", marginBottom: "2em" },
  strong: {
    fontWeight: "bold",
    fontSize: "16px"
  },
  cardStyle: {
    width: "100%",
    display: "block",
    transitionDuration: "0.3s",
    height: "550px",
    marginBottom: "10px",
    //paddingBottom: "75px"
  },
  cardHeaderStyle: {
    textDecoration: "underline",
    letterSpacing: "2px",
    textTransform: "uppercase",
    textAlign: "center",
    color: "#000000",
    paddingTop: "20px",
    fontSize: "16px"
  },
  mainCardStyle: { display: "block", transitionDuration: "0.3s" },
  ElasticColumn: {
    marginLeft: "5px",
    marginRight: "5px",
    flexGrow: 1,
    flexBasis: "50%"
  },
  CardContent: {
    fontSize: "19px",
    paddingLeft: "4px",
    paddingRight: "4px",
    display: "flex",
    justifyContent: "center"
  },
  colorBlack: {
    color: 'black',
    marginRight: '10px'
  },
  buttonColor: {
    backgroundColor:'#dddddd ',
  },
  aligTextButton: {
    display: 'inline-block',
    color: 'white',
  },
  centerText: {
    textAlign: "center",
  }, 
  widthFull: {
    width: '100%'
  },
  widthPartial2: {
    width: '50%'
  },
  flexPadtop: { display: "flex", paddingTop: '15px' },

  flexCenterV: { 
    display: "flex", 
    position: 'absolute',
    top: '50%',
    transform: 'translate(0, -50%)' 
  },
  rightColCenterV: { flex: 1, marginLeft: "1em",  position: 'relative' },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/dashboard/Styles.js